// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"396":"001aea08","513":"14cf49b8"}[chunkId] + ".chunk.css";
};